var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1945 5110 c-655 -74 -1224 -420 -1590 -970 -382 -574 -460 -1324 -205 -1969 110 -278 264 -513 475 -726 352 -355 761 -561 1249 -630 149 -21 437 -21 581 0 376 55 720 198 1005 416 l93 71 636 -636 c443 -443 647 -640 673 -651 93 -38 195 5 239 100 23 49 24 94 4 143 -11 26 -208 230 -651 673 l-636 636 71 93 c218 285 361 629 416 1005 21 144 21 432 0 581 -69 488 -275 897 -630 1249 -325 322 -736 530 -1185 600 -124 19 -432 27 -545 15z m505 -393 c516 -89 956 -384 1230 -825 176 -285 261 -585 262 -927 1 -180 -11 -278 -53 -445 -157 -630 -659 -1132 -1289 -1289 -167 -42 -265 -54 -445 -53 -342 1 -642 86 -927 262 -448 278 -744 726 -829 1255 -20 119 -17 427 4 553 63 367 236 702 501 968 300 299 643 461 1096 518 68 8 366 -3 450 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205 3991 c-78 -35 -212 -203 -295 -369 -97 -194 -133 -352 -134 -582 -1 -138 1 -159 20 -194 59 -114 202 -141 298 -57 44 39 56 84 56 218 0 264 73 463 236 650 85 97 102 158 65 238 -45 98 -151 139 -246 96z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.3550fd08.svg";
export { ForwardRef as ReactComponent };